"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var fonts = {
  family: 'Vodafone',
  extension: 'woff',
  fontFiles: [{
    weight: 200,
    file: 'vodafone-light'
  }, {
    weight: 400,
    file: 'vodafone-regular'
  }, {
    weight: 700,
    file: 'vodafone-bold'
  }, {
    weight: 900,
    file: 'vodafone-extra-bold'
  }]
};
var _default = fonts;
exports["default"] = _default;